module.exports = __webpack_public_path__ + "img/example-left.2a820fd.png";